import React from 'react';
import { Dimmer, Header, Loader, Modal, SemanticICONS } from 'semantic-ui-react';

import { ModalEnfocable } from 'src/componentes/semantic-ui-extended';

interface Props {
    cargando?: boolean;
    cabecera?: string;
    iconoCabecera?: SemanticICONS;
    acciones?: React.ReactNode;
    contenido?: string;
}

const ModalBase: React.FunctionComponent<Props> = props => {
    const { cargando = false, cabecera, iconoCabecera, contenido, acciones, children } = props;

    return (
        <ModalEnfocable open>
            <Header icon={iconoCabecera} content={cabecera} />

            {cargando ? (
                <Dimmer.Dimmable as={Modal.Content} dimmed>
                    <Dimmer active inverted>
                        <Loader />
                    </Dimmer>
                </Dimmer.Dimmable>
            ) : (
                <Modal.Content>{contenido || children}</Modal.Content>
            )}

            <Modal.Actions>{acciones}</Modal.Actions>
        </ModalEnfocable>
    );
};

export default ModalBase;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/Gastos/componentes/ModalBase.tsx